export const ima3 = (props) => {
    const existingScript = document.getElementById('ima3');
     if (!existingScript) {
        return new Promise((resolve, reject) => {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.id = 'ima3';
            script.src = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';
            script.onload = () => {
                resolve();
            }
            script.onerror = () => {
                if (props.enableAdBlockWarning) {
                    showAdBlockerWarning(); 
                }
                reject('Cannot load ima3 JS');
                document.body.removeChild(script);
            }
            document.body.appendChild(script);
        })
    }
};

const sitecolor = window.settings.brand.cta.primary.backgroundColor;

function showAdBlockerWarning() {
    const warning = document.createElement('div');
    warning.innerHTML = `
        <span style="flex-grow: 1; padding: 10px;">It looks like an ad blocker is preventing ads from loading. Please disable it and refresh the page to view the content.</span>
    <button onclick="location.reload()" style="background:sitecolor;color:white;border:1px solid white;padding:8px 16px;font-size:14px;cursor:pointer;border-radius:4px;">Retry</button> `;
    
    Object.assign(warning.style, {
        position: 'fixed', top: 0, left: 0, width: '100%', background: sitecolor, color: '#fffff', 
        textAlign: 'center', padding: '15px', fontSize: '16px', fontFamily: 'Arial, sans-serif', 
        zIndex: 9999,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    });
    
    document.body.appendChild(warning);
}

export const platform = () => {
    const existingScript = document.getElementById('platform');
     if (!existingScript) {
        return new Promise((resolve, reject) => {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.id = 'platform';
            script.src = window.settings.layoutUrlBase+'assets/platform.js';
            script.onload = () => {
                resolve();
            }
            script.onerror = () => {
                reject('Cannot load platform JS')
                document.body.removeChild(script);
            }
            document.body.appendChild(script);
        })
    }
}
export const castSDK = () => {
    const existingScript = document.getElementById('castSDK');
     if (!existingScript) {
        return new Promise((resolve, reject) => {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.id = 'castSDK';
            script.src = 'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1';
            script.onload = () => {
                resolve();
            }
            script.onerror = () => {
                reject('Cannot load castSDK JS')
                document.body.removeChild(script);
            }
            document.body.appendChild(script);
        })
    }
}